import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import * as firebase from 'firebase'

import './UpdateAvatar.css'

class UserAvatar extends FirebaseComponent {
  constructor() {
    super()
    this.state.profile = {}
    this.uploadImage = this.uploadImage.bind(this)

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase.database().ref(`profiles/${user.uid}`)
          .on('value', snapshot => {
            this.setState({ profile: snapshot.val() })
          })
      }
    })
  }

  uploadImage(event) {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = ev => {
      const imageRef = firebase.database().ref(`profiles/${this.state.uid}/profileImage`)
      const image = ev.target.result;
      imageRef.set(image);
    };

		reader.readAsDataURL(file);
  }

  render() {
    return (
      <div>
        <div className="update-avatar">
					<div className="update-profile-image-form-control form-control">
						<label for="profileFileInput">Update profile image</label>
						<input id="profileFileInput" type="file" onChange={this.uploadImage} accept=".jpg, .jpeg, .png"/>
						<p class="help-block">Your image must be in .jpg or .png format</p>
					</div>
        </div>
      </div>
    )
  }
}

export default UserAvatar



// WEBPACK FOOTER //
// ./src/UpdateAvatar.js